import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import useVoyagerStore from '../stores/useVoyagerStore';
import { PHONE_QUERY, useChatSidebar } from './chatSidebarState';
import { useCloseToast } from './closeUndo';
import { onScreen, recentMarker, useFinishedToast, useSimpleSidebar } from './simpleSidebarState';
import { isOpenThread } from '../stores/slices/threadsSlice';
import ShellToast from './ShellToast';

function open(threadId: string) {
  useFinishedToast.setState({ toast: null });
  useSimpleSidebar.getState().showPlaceholder(null);
  useChatSidebar.getState().setDrawerOpen(false);
  useVoyagerStore.setState({ objectiveSpaceId: null } as any);
  useVoyagerStore.getState().loadThread(threadId);
}

/** "<title>" is ready · Open — when a thread not on screen finishes (the mock's toast). */
export default function FinishedToastView({ inDrawer = false }: { inDrawer?: boolean }) {
  const toast = useFinishedToast((s) => s.toast);
  const generation = useVoyagerStore((s) => s.threadsGeneration);
  const phone = useMediaQuery(PHONE_QUERY);
  const drawerOpen = useChatSidebar((s) => s.drawerOpen);
  // the close Undo sits where this would: this one stands above it
  const stacked = useCloseToast((s) => !!s.toast);
  const placeholder = useSimpleSidebar((s) => s.placeholder);
  const awayDone = useSimpleSidebar((s) => s.awayDone);
  // read live: the thread's title now, and whether it still has news — a thread deleted, closed or
  // already opened (its marker cleared), or the one now on screen, has nothing to announce
  const shown = useVoyagerStore((s) => {
    if (!toast) return null;
    const thread = s.savedThreads.find((t) => t.id === toast.threadId);
    if (!thread || !isOpenThread(thread)) return null;
    if (s.currentThreadId === toast.threadId && onScreen(s, placeholder)) return null;
    const marker = recentMarker(s as any, toast.threadId, awayDone);
    return marker === 'done' || marker === 'needs' || marker === 'fail' ? { title: thread.title, marker } : null;
  }, (a, b) => a === b || (!!a && !!b && a.title === b.title && a.marker === b.marker));
  if (!toast || !shown || toast.generation !== generation) return null;
  if (!inDrawer && phone && drawerOpen) return null;
  return <ShellToast testId={inDrawer ? 'finished-toast-drawer' : 'finished-toast'} inDrawer={inDrawer} stacked={stacked}
    text={<>“{shown.title}” {shown.marker === 'needs' ? 'needs your answer' : shown.marker === 'fail' ? 'couldn’t be answered' : 'is ready'}</>}
    actions={[{ label: 'Open', onClick: () => open(toast.threadId) }]} onDismiss={() => useFinishedToast.setState({ toast: null })} />;
}

